import { DismissAction, ModalActionTypes } from '../types';

export const dismissModalAction: DismissAction = {
  type: ModalActionTypes.DISMISS,
};
